import React from "react";
import injectSheet from "react-jss";
import { LinkButton } from "../../";

const OfferContact = (props) => {
  const {
    classes,
    clientSelection: {
      email,
      firstName,
      lastName,
      location,
      message,
      phone,
      street,
      streetNumber,
      zip,
      offerId,
    },
    hasRequiredData,
  } = props;

  return (
    <div className={`${classes.container}`}>
      <div className={`${classes.content}`}>
        <p>
          {`${firstName} ${lastName}`}
          <br />
          {`${street} ${streetNumber}`}
          <br />
          {`${zip} ${location}`}
          <br />
        </p>
        <p>
          {`${email}`}
          <br />
          {`${phone}`}
        </p>
        <p>{`${message}`}</p>
        {hasRequiredData ? (
          <div className={classes.linkButton}>
            <LinkButton
              href={`${process.env.REACT_APP_PDF_GENERATOR}${offerId}`}
              text="Angebot als PDF herunterladen"
              external
              primary
              style={{ padding: 0 }}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

const styles = (theme) => ({
  container: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    padding: `${theme.sizes.gutter / 2}px`,
    paddingBottom: `${theme.sizes.gutter}px`,
  },
});

export default injectSheet(styles)(OfferContact);



// WEBPACK FOOTER //
// ./src/modules/offer/components/offerContact.jsx